import Icon from 'veui/components/Icon'
import { IconElement } from 'dls-icons-vue'

Icon.register('element', IconElement)
